import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { biTypologieDto } from 'src/app/models/biTypologieDto';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TypologieLotService {

  PATH_ALL_TYPOLOGIE_LOT = "/programmes-lots/typo-lot/all";
  
  constructor(private readonly http: HttpClient) { }
  
  getAllTypologieLot = (): Observable<biTypologieDto[]> => {
    const url = environment.host.domaine + this.PATH_ALL_TYPOLOGIE_LOT;
    return this.http.get<biTypologieDto[]>(url)
  }
}
